import { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { deriveKeyFromCredential } from '../utils/encryptionUtils';

const EncryptionKeyContext = createContext(null);

export const EncryptionKeyProvider = ({ children }) => {
    const [key, setKey] = useState(null);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const derivedKey = await deriveKeyFromCredential(user.uid);
                setKey(derivedKey);
            } else {
                setKey(null);
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <EncryptionKeyContext.Provider value={{ key, setKey }}>
            {children}
        </EncryptionKeyContext.Provider>
    );
};

export const useEncryptionKey = () => useContext(EncryptionKeyContext);
